// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3028": "011ac1bca936","5585": "10b5660c5807","6291": "77e3557498ef","6863": "454c9f289029","8358": "4e3631b20f22","8874": "06a56d8c6275",}[chunkId] + ".css"
}